import React from 'react';
import { FaBan } from 'react-icons/fa';

// Full-page lock shown when the network/device access-control gate blocks a
// request (company network restriction, or a device IT Admin has revoked) —
// see the 403 interceptor in services/api.js and backend's
// services/accessControl.js. Super Admin / IT Admin are always exempt from
// these rules, so they never land here.
const AccessLocked = () => {
  const message = sessionStorage.getItem('accessBlockMessage') || 'Access to this application is restricted.';

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg-color, #f8fafc)', padding: '24px' }}>
      <div style={{ maxWidth: '480px', textAlign: 'center', background: 'var(--card-bg, #fff)', border: '1px solid var(--border-color, #e5e7eb)', borderRadius: '12px', padding: '32px 28px' }}>
        <FaBan style={{ fontSize: '36px', color: 'var(--danger-color, #dc2626)', marginBottom: '12px' }} />
        <h2 style={{ margin: '0 0 10px', fontSize: 'var(--fs-xl)' }}>Access Restricted</h2>
        <p style={{ color: 'var(--text-secondary)', fontSize: 'var(--fs-md)', margin: '0 0 20px' }}>{message}</p>
        <a href="/login" style={{ fontSize: 'var(--fs-md)' }}>Back to sign-in</a>
      </div>
    </div>
  );
};

export default AccessLocked;
